import * as Card from "card";

export default {
  step: function(newValue) {
    if (newValue === 3) {
      this.loadAvailableInstallments()
      this.createBoostPurchase()
        .then(() => {
          if (this.step === 3 && this.paymentMethod === 3) {
            this.createPixPayment()
          }
        })

      if (this.boost && this.boost['@id']) {
        this.setPaymentMethod()
      }

      if (this.paymentMethod === 1) {
        new Card({
          form: '#card-form',
          container: '#card-wrapper',
          formSelectors: {
            numberInput: '#creditCardNumber',
            expiryInput: 'input#creditCardExpDate',
            cvcInput: 'input#creditCardCode',
            nameInput: 'input#creditCardName'
          },
          placeholders: {
            number: '•••• •••• •••• ••••',
            name: 'Nome Completo',
            expiry: '••/••',
            cvc: '•••'
          },
          messages: {
            validDate: 'Validade',
            monthYear: 'mm/aa',
          }
        });
      }

    }

    if(newValue === 1) {
      this.boost = {}
    }
  },
}
